/**
 * Dravonix Configuration
 * ======================
 * Central config file for all links, social media, and partner info
 * Update this file to change links across the entire website
 */

export const config = {
  // Company Info
  company: {
    name: 'Dravonix',
    tagline: 'Engineering the Decentralized Future',
    email: 'support@dravonixglobal.com',
    phone: '+91 99624 61250',
    whatsapp: '919962461250'
  },

  // Social Media Links
  social: {
    whatsapp: 'https://wa.me/919962461250',
    telegram: 'https://t.me/dravonix_2026',
    twitter: 'https://x.com/Dravonix2026',
    facebook: 'https://www.facebook.com/share/1D5YjEDDV7/',
    instagram: 'https://instagram.com/dravonix2026',
    youtube: 'https://www.youtube.com/@Dravonix-2026',
    linkedin: 'https://linkedin.com/company/dravonix',
    github: 'https://github.com/dravonix',
    discord: 'https://discord.gg/dravonix'
  },

  // Partner Companies
  partners: [
    {
      id: 'way2pay',
      name: 'Way 2 Pay',
      description: 'Cryptocurrency Payment Gateway',
      logo: '/assets/partners/way2pay.png',
      website: 'https://way2pay.com',
      color: '#00D4FF'
    },
    {
      id: 'coinzaar',
      name: 'Coinzaar',
      description: 'Crypto Listing Platform',
      logo: '/assets/partners/coinzaar.png',
      website: 'https://coinzaar.com',
      color: '#D4A853'
    },
    {
      id: 'brainstorm',
      name: 'Brainstorm Academy',
      description: 'Education Academy',
      logo: '/assets/partners/brainstorm.png',
      website: 'https://brainstormacademy.com',
      color: '#A855F7'
    },
    {
      id: 'coinsarrow',
      name: 'Coinsarrow',
      description: 'Listing & Crypto Audit',
      logo: '/assets/partners/coinsarrow.png',
      website: 'https://coinsarrow.com',
      color: '#10B981'
    },
    {
      id: 'sendengine',
      name: 'SendEngine',
      description: 'Crypto Multisender',
      logo: '/assets/partners/sendengine.png',
      website: 'https://sendengine.com',
      color: '#F97316'
    },
    {
      id: 'zabex',
      name: 'Zabex',
      description: 'USDT P2P Exchange',
      logo: '/assets/partners/zabex.png',
      website: 'https://zabex.com',
      color: '#EC4899'
    }
  ],

  // Process Steps
  process: [
    {
      step: '01',
      title: 'Discovery',
      description: 'Deep dive into your vision and requirements.',
      icon: 'fa-comments'
    },
    {
      step: '02',
      title: 'Strategy',
      description: 'Craft detailed roadmap and specifications.',
      icon: 'fa-map'
    },
    {
      step: '03',
      title: 'Development',
      description: 'Build with agile sprints and updates.',
      icon: 'fa-code'
    },
    {
      step: '04',
      title: 'Testing',
      description: 'Rigorous QA and security audits.',
      icon: 'fa-shield-alt'
    },
    {
      step: '05',
      title: 'Launch',
      description: 'Smooth deployment with support.',
      icon: 'fa-rocket'
    }
  ],

  // CTA Section
  cta: {
    title: 'Ready to Build?',
    subtitle: 'Schedule a free strategy call with our blockchain & software experts.',
    benefits: ['Free Consultation', 'No Obligation', 'Expert Advice'],
    buttonText: 'Book Strategy Call'
  },

  // Footer Links
  footer: {
    services: [
      { name: 'Blockchain Development', href: '#services' },
      { name: 'Smart Contracts', href: '#services' },
      { name: 'DeFi Solutions', href: '#services' },
      { name: 'NFT Marketplace', href: '#services' },
      { name: 'Web & Mobile Apps', href: '#services' }
    ],
    company: [
      { name: 'About Us', href: '#protocol' },
      { name: 'Our Projects', href: '#projects' },
      { name: 'Partners', href: '#partners' },
      { name: 'Tech Stack', href: '#techstack' },
      { name: 'Contact', href: '#contact' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' }
    ]
  }
};

export default config;
